import React, { useReducer, useContext } from 'react';

export const actions = {
  SET_COLOR_PICKER: 'set-color-picker',
};

const initialState = {
  colorPicker: '',
};

const ShophireContext = React.createContext(undefined);

const reducer = (state, action) => {
  switch (action.type) {
    case actions.SET_COLOR_PICKER:
      return {
        ...state,
        colorPicker: action.payload,
      };

    default:
      throw new Error();
  }
};

export const ShophireProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <ShophireContext.Provider value={{ state, dispatch }}>{children}</ShophireContext.Provider>;
};

export const useShophireReducer = () => {
  const ctxValue = useContext(ShophireContext);
  if (ctxValue === undefined) throw new Error('Expected an ShophireContext somewhere in the react tree to set context value');
  return ctxValue;
};
